import { useState, useCallback } from 'react';
import { getLocation } from 'src/components/common/api/getLocationAPI';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { ILocation } from 'src/types/Location';

export type UseFetchLocationReturnType = {
  isLoading: boolean;
  hasError: boolean;
  location: ILocation | null;
  fetchLocation: (locationId: string) => Promise<void>;
};

export const useFetchLocation = (
  corpId: string
): UseFetchLocationReturnType => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const [location, setLocation] = useState<ILocation | null>(null);

  const fetchLocation = useCallback(
    async (locationId: string): Promise<void> => {
      try {
        setIsLoading(true);
        setHasError(false);

        const locationData = await getLocation(corpId, locationId);

        setLocation(locationData);
      } catch (err) {
        setHasError(true);
        pushErrorFromAPI(err);
      } finally {
        setIsLoading(false);
      }
    },
    [corpId]
  );

  return {
    isLoading,
    hasError,
    location,
    fetchLocation,
  };
};
